import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

/**
 * Sección estándar de los paneles de operación: Card del theme con título h3,
 * subtítulo secundario opcional y acción a la derecha. Jerarquía visual
 * consistente (cada bloque vive en su card).
 */
export const SectionCard = ({
  title,
  subtitle,
  action,
  children,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}) => (
  <Card variant="outlined">
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5, mb: subtitle ? 0.5 : 2 }}>
        <Typography variant="h3">{title}</Typography>
        <Box sx={{ flex: 1 }} />
        {action}
      </Box>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </CardContent>
  </Card>
);
